import { GraphQLClient } from 'graphql-request';

const url = process.env.REACT_APP_SHOPIFY_STORE_URL;
const access_token = process.env.REACT_APP_SHOPIFY_SF_ACCESS_TOKEN;

const graphQLClient = new GraphQLClient(url + '/api/2023-01/graphql.json', {
    // credentials: 'include',
    mode: 'cors',
});

graphQLClient.setHeaders({
    'Content-Type': 'application/json',
    'X-Shopify-Storefront-Access-Token': access_token,
});

export { graphQLClient };
